import { call, put, takeLatest } from 'redux-saga/effects';

import { getTaxAuthorityAffiliates } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getTaxAuthorityAffiliates, action.payload);
  yield put(
    response.isOk ? requestSuccess(response.data, action.payload) : requestFailure(response.error),
  );
}

export default function* taxAuthorityAffiliatesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
